<template>
  <div v-if="item">
    <h2>ID группы: #{{ item.id }}</h2>
    <div class="row">
      <div class="col-12 col-md-6">
        <fg-input type="text" label="Название" v-model="item.name"></fg-input>
        <checkbox v-model="item.show_price" :value="1" color="#f50057"
          >Показать цену</checkbox
        >
        <fg-input
          type="text"
          label="Максимальная цена просмотра"
          v-model="item.max_price"
        ></fg-input>
        <fg-input
          type="text"
          label="Скидка (%) на товары"
          v-model="item.sale"
        ></fg-input>
      </div>
    </div>
  </div>
</template>

<script>
/**Меняю добавление модалку */
export default {
  data: () => ({
    cardLink: "admin/groups/card",
    cardSetLink: "admin/groups/update",
    item: null,
  }),

  props: ["id"],
  created() {
    this.getItem();
  },
  methods: {
    getItem() {
      this.$loading(true);
      if (this.id) {
        this.$http
          .get(this.cardLink, {
            params: {
              id: this.id,
            },
          })
          .then((response) => {
            this.item = response.data;
          })
          .catch(() => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.$loading(false);
            }, 400);
          });
      }
    },
    updateItem() {
      this.loading = true;
      this.$loading(true);
      this.$http
        .put(this.cardSetLink, this.item)
        .then((response) => {})
        .catch((error) => {
          errorNotify(error, this);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style>
</style>
